import { TENANT_TYPES } from 'src/utils/tenant-detection';

export const TENANT_TERMINOLOGY = {
  [TENANT_TYPES.CAMPAIGN]: {
    voter: 'voter',
    voters: 'voters',
    Voter: 'Voter',
    Voters: 'Voters',
    campaign: 'campaign',
    campaigns: 'campaigns',
    Campaign: 'Campaign',
    Campaigns: 'Campaigns',
  },
  [TENANT_TYPES.LEGISLATIVE]: {
    voter: 'constituent',
    voters: 'constituents',
    Voter: 'Constituent',
    Voters: 'Constituents',
    campaign: 'office',
    campaigns: 'offices',
    Campaign: 'Office',
    Campaigns: 'Offices',
  },
};

export const TENANT_FEATURES = {
  [TENANT_TYPES.CAMPAIGN]: {
    campaignFinance: true,
    electionMode: true,
    fundraising: true,
    volunteering: true,
    canvassing: true,
    billTracking: false,
    legislativeCalendar: false,
    constituentServices: false,
  },
  [TENANT_TYPES.LEGISLATIVE]: {
    campaignFinance: false,
    electionMode: false,
    fundraising: false,
    volunteering: false,
    canvassing: false,
    billTracking: true,
    legislativeCalendar: true,
    constituentServices: true,
  },
};

export const TENANT_UI_CONFIG = {
  [TENANT_TYPES.CAMPAIGN]: {
    brandName: 'RightInsight',
    primaryColor: '#default',
    dashboardTitle: 'Campaign Dashboard',
  },
  [TENANT_TYPES.LEGISLATIVE]: {
    brandName: 'RightInsight Legislative',
    primaryColor: '#default',
    dashboardTitle: 'Legislative Dashboard',
  },
};

export const getTenantConfig = (tenantType) => ({
  type: tenantType,
  terminology: TENANT_TERMINOLOGY[tenantType],
  features: TENANT_FEATURES[tenantType],
  ui: TENANT_UI_CONFIG[tenantType],
});
